import { render } from "./Move1BlockComponent.vue?vue&type=template&id=aefd9eae&scoped=true"
import script from "./Move1BlockComponent.vue?vue&type=script&lang=js"
export * from "./Move1BlockComponent.vue?vue&type=script&lang=js"

import "./Move1BlockComponent.vue?vue&type=style&index=0&id=aefd9eae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aefd9eae"

export default script